import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';
import { IDeployPriorityGrading } from '../interfaces/deploy-priority/deploy-priority-grading';
import { IPageResult } from '../interfaces/page-result';

@Injectable({
  providedIn: 'root',
})
export class DeployPriorityGradingsService extends BaseDataService {
  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getGradings(): Promise<IPageResult<IDeployPriorityGrading>> {
    const url = '/api/DeployPriorityGrading';

    return this.handleRequest<any>(
      this.http.get<IPageResult<IDeployPriorityGrading>>(url),
      this.handlersFactory.getForReadAll(),
    );
  }

  updateGrading(dto: IDeployPriorityGrading): Promise<void> {
    const url = '/api/DeployPriorityGrading';

    return this.handleRequest<any>(
      this.http.post<IDeployPriorityGrading>(url, dto),
      this.handlersFactory.getForReadAll(),
    );
  }

  recalculateAllGradings(): Promise<void> {
    const url = '/api/DeployPriority/RecalculateAllPriorities';

    return this.handleRequest<any>(
      this.http.post<void>(url, null),
      this.handlersFactory.getForReadAll(),
    );
  }

  recalculateAllSensitivityScores(): Promise<void> {
    const url = '/api/DeployPriority/RecalculateAllDeploySensitivityScores';

    return this.handleRequest<any>(
      this.http.post<void>(url, null),
      this.handlersFactory.getForReadAll(),
    );
  }
}
